const state = {
    salesperson: [],
    loading: false
};

export default state;